/**
 * Calendar helpers — download .ics or open Google Calendar for a given event.
 */

const toICSDate = (iso) => {
  // 2026-07-04T17:00:00Z  →  20260704T170000Z
  return iso.replace(/[-:]/g, '').replace(/\.\d{3}/, '');
};

export function buildICS(event) {
  const uid = `${event.slug}@thewementality.com`;
  const now = toICSDate(new Date().toISOString().replace(/\.\d{3}/, ''));
  const dtstart = toICSDate(event.startISO);
  const dtend = toICSDate(event.endISO);
  const summary = `${event.title}${event.subtitle ? ' — ' + event.subtitle : ''}`;
  const description = (event.description || '').replace(/\n/g, '\\n');
  const location = [event.location, event.locationDetail].filter(Boolean).join(', ');
  const url = event.ctaPrimary?.href || '';

  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//The WE Mentality//Culture Align Events//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${now}`,
    `DTSTART:${dtstart}`,
    `DTEND:${dtend}`,
    `SUMMARY:${summary}`,
    `DESCRIPTION:${description}`,
    `LOCATION:${location}`,
    url ? `URL:${url}` : '',
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');
}

export function downloadICS(event) {
  const blob = new Blob([buildICS(event)], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${event.slug}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function googleCalendarUrl(event) {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: `${event.title}${event.subtitle ? ' — ' + event.subtitle : ''}`,
    dates: `${toICSDate(event.startISO)}/${toICSDate(event.endISO)}`,
    details: event.description || '',
    location: [event.location, event.locationDetail].filter(Boolean).join(', '),
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function shareEvent(event) {
  const url = event.ctaPrimary?.href || window.location.href;
  const title = `${event.title} — ${event.subtitle || ''}`;
  if (navigator.share) {
    return navigator.share({ title, text: event.description, url }).catch(() => {});
  }
  // Fallback: copy to clipboard
  navigator.clipboard?.writeText(url);
  return Promise.resolve();
}
